import { Component } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { NgbDatepicker, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { AdditionOfManpowerService } from '../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../Model/Common/common.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-manpower-alteration-form',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, NgbDatepicker, DataTablesModule],
  templateUrl: './manpower-alteration-form.component.html',
  styleUrl: './manpower-alteration-form.component.scss'
})
export class ManpowerAlterationFormComponent {
  isDisabled: boolean = false;
  BranchMaster: any[] = [];
  DesignationLoad: any[] = [];
  Shift: any[] = [];
  ClientLoad: any[] = [];
  DutyLoad: any[] = [];
  SiteLoad: any[] = [];

  BranchId: number = 0;
  BranchName: string = '';
  ClientId: number = 0;
  ClientName: string = '';
  Designation: string = '';
  DesignationId: number = 0;
  ShiftTitle: string = '';
  ShiftID: number = 0;
  DutyId: number = 0;
  Duty: string = '';

  SiteId: number = 0;
  SiteName: string = '';
  WorkOrderNumber: string = ''
  RecallData: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  //rowEnabled: boolean[] = [];
  selectAllRows: boolean = false;
  dtoptions: DataTables.Settings = {};
  constructor(private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private siteadditionreduction: AdditionOfManpowerService,
    protected common: CommonService,
    private tooltip: TooltipService,
  ) {
    // this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }
  ngOnInit(): void {
    //this.loadSiteData();
    this.ComboLoad('Branch');
    this.ComboLoad('shift');
  }

  onSelectChange(type: string) {
    if (type === 'Designation') {
      const selected = this.DesignationLoad.find(designation => designation.DesignationMasterID === this.DesignationId);
      this.Designation = selected ? selected.DesignationName : null;
      this.DutyId = 0
      this.Duty = ''
      this.RecallData = []
    }
    else if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
      this.ClientId = 0
      this.ClientName = ''
      this.SiteId = 0
      this.SiteName = ''
      this.Designation = ''
      this.DesignationId = 0;
      this.DutyId = 0
      this.Duty = ''
      this.RecallData = []

    }
    else if (type == 'Client') {
      const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
      this.ClientName = selected ? selected.ClientGroupName : null;
      this.SiteId = 0
      this.SiteName = ''
      this.Designation = ''
      this.DesignationId = 0;
      this.DutyId = 0
      this.Duty = ''
      this.RecallData = []
    }
    else if (type === 'Shift') {
      const selected = this.Shift.find(shift => shift.ShiftMasterID === this.ShiftID);
      this.ShiftTitle = selected ? selected.ShiftTitle : null;
      this.RecallData = []
    }
    else if (type === 'Duty') {
      const selected = this.DutyLoad.find(duty => duty.DutyMasterID === this.DutyId);
      this.Duty = selected ? selected.DutyName : null;
      this.RecallData = []
    }
    else if (type === 'Site') {
      const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
      this.SiteName = selected ? selected.SiteName : null;
      this.Designation = ''
      this.DesignationId = 0;
      this.DutyId = 0
      this.Duty = ''
      this.RecallData = []
    }
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,
      'DesignationId': (Combotype == 'Duty') ? this.DesignationId : 0,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;

        } else if (Combotype == 'Client') {
          this.ClientLoad = response.ComboLoad;

        } else if (Combotype == 'Site') {
          this.SiteLoad = response.ComboLoad;

        } else if (Combotype == 'Designation') {
          this.DesignationLoad = response.ComboLoad;

        } else if (Combotype == 'Duty') {
          this.DutyLoad = response.ComboLoad;

        }
        else if (Combotype == 'shift') {
          this.Shift = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }

  validateInputs(): boolean {
    if (!this.BranchName || this.BranchName === '') {
      this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.ClientName || this.ClientName === '') {
      this.toast.show({ message: 'Please select Client!', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.SiteName || this.SiteName === '') {
      this.toast.show({ message: 'Please select Site!', type: toastTypeEnum.warning });
      return false;
    }
    return true;
  }

  Load() {
    if (!this.validateInputs()) {
      return;
    }
    const data = {
      SelectType: 'S',
      ESS_ShiftWiseManpowerMasterId: 0,
      ESS_ShiftWiseManpowerDetailsId: 0,
      AllocationType: '',
      WoNo: this.WorkOrderNumber,
      SiteId: this.SiteId,
      DesignationId: this.DesignationId,
      DutyId: this.DutyId,
      ShiftId: this.ShiftID
    }
    console.log('load log data', data);
    this.isDisabled = true;
    this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet(data).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          this.RecallData = Object.values(data.Table);
          console.log('Work order data ', this.RecallData);
          this.isDisabled = false;
        }
        else {
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
          this.isDisabled = false;
          this.RecallData = [];
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }

  toggleSelectAllRows() {
    this.selectAllRows = !this.selectAllRows;
    this.RecallData.forEach(item => {
      item.checked = this.selectAllRows;
    });
  }

  toggleRowEnabled(index: number) {
    this.RecallData[index].checked = !this.RecallData[index].checked;
  }

  Save() {
    if (this.RecallData.length === 0) {
      this.toast.show({ message: 'No Data Available', type: toastTypeEnum.warning });
      return
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save?'
    modalRef.result.then((result: any) => {
      if (result) {
        this.CheckManpowerValidation();
      }
    }).catch(() => {

    });
  }
  CheckManpowerValidation() {
    const validation = {
      SelectType: 'WO',
      ESS_ShiftWiseManpowerMasterId: '',
      ESS_ShiftWiseManpowerDetailsId: '',
      AllocationType: '',
      WoNo: this.WorkOrderNumber,
    };
    this.isDisabled = true
    this.siteadditionreduction.ESS_SiteManpowerValidation(validation).subscribe(
      data => {
        if (data.Error_Code === '01') {
          this.Insertupdate();
          this.isDisabled = false;
        } else {
          const modalRef = this.modalService.open(ConfirmationComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message
          modalRef.result.then((result: any) => {
            if (result) {
              this.Insertupdate();
              this.isDisabled = false;
            }
          }).catch(() => {

          });
        }
      }
    );
  }

  Insertupdate() {
    const masterId = this.RecallData[0].ESS_ShiftWiseManpowerMasterId;
    const manpower = this.RecallData.map(site => {
      return {
        DesignationId: site.DesignationId,
        DutyId: site.DutyId,
        ShiftId: site.ShiftId,
        FromDate: site.FromDate,
        ToDate: site.ToDate,
        NoOfPerson: site.NoOfPerson,
        RefESS_ShiftWiseManpowerDetailsId: site.RefESS_ShiftWiseManpowerDetailsId,
        Remarks: site.Remarks
      };
    });
    const additionData = {
      SelectType: 'D',
      ESS_ShiftWiseManpowerMasterId: masterId,
      ESS_ShiftWiseManpowerDetailsId: '',
      ESS_ShiftWiseManpowerDetails: manpower,
      WoNo: this.WorkOrderNumber,
      WoDate: '',
      SiteId: this.SiteId,
      UserID: this.User.UserId,
      AllocationType: 'R',
      Attachment: '',
    };
    console.log('date', additionData);
    // this.isDisabled = true
    // this.siteadditionreduction.ESS_SiteManpowerAdditionReduction(additionData).subscribe(
    //   data => {

    //   },
    //   error => {
    //     console.error('Error:', error);
    //   });
  }
}
